(function ($) {

	// Single product modal swiper
	var single_product_lightbox_swiper,
		single_product_lightbox_swiper_thumbs,
		open_attribute = "data-open-lightbox-gallery",
		close_attribute = "data-close-lightbox-gallery"

	function init_gallery(){

		single_product_lightbox_swiper_thumbs = new Swiper(".product__thumbnail-lightbox-swiper", {
			spaceBetween: 10,
			slidesPerView: 'auto',
			// freeMode: true,
			watchSlidesProgress: true,
			// cssMode: true,
			observer: true,
			direction: 'vertical',
			threshold: 10,
			mousewheel: {
				forceToAxis: true,
			},
		});

		// Single product gallery Swiper
		single_product_lightbox_swiper = new Swiper('.product-detail-gallery-lightbox-swiper', {
			// initialSlide: initialSlide,
			speed: 300,
			slidesPerView: 1,
			touchReleaseOnEdges: true,
			simulateTouch: true,
			allowTouchMove: true,
			lazy: {
				loadPrevNext: true,
				loadPrevNextAmount: 2
			},
			pagination: {
				el: '.swiper-lightbox-pagination',
				type: 'fraction',
			},
			navigation: {
				nextEl: ".swiper-lightbox-arrow-next",
				prevEl: ".swiper-lightbox-arrow-prev",
			},
			thumbs: {
				swiper: single_product_lightbox_swiper_thumbs,
			},
			on: {
				slideChange: function () {
					$('.zoomed').removeClass('zoomed');
				},
			},
		});




		document.querySelectorAll('.panzoom').forEach(el => {
			const panzoom = Panzoom(el, {
				maxScale: 4,
				minScale: 1,
				step: 0.5,
				contain: 'outside',
				bounds: false,
				boundsPadding: 0,
				zoomDoubleClickSpeed: 1, // nebo 0, pokud chceš zakázat double click zoom
			});

			const swiper = single_product_lightbox_swiper;

			// Double tap zoom
			let lastTap = 0;
			el.parentElement.addEventListener('touchstart', function (e) {

				const scale = panzoom.getScale();
				if (swiper) {
					swiper.allowTouchMove = scale <= 1; // swipe povolený jen pokud není přiblíženo
				}

				// Více prstů = pinch, double tap ignoruj
				if (e.touches.length > 1) {
					return;
				}

				const currentTime = new Date().getTime();
				const tapLength = currentTime - lastTap;
				if (tapLength < 300 && tapLength > 0) {

					const scale = panzoom.getScale();
					if (scale === 1) {
						panzoom.zoom(2);
					}
					else if (scale <= 2) {
						panzoom.zoom(scale + 1);
					} else {
						panzoom.reset();
					}
				}

				lastTap = currentTime;
			});


		});

	}

	// Init sidebar open
	$("[" + open_attribute + "]").click(function () {
		var init_slide = parseInt($(this).attr('lightbox-gallery-slide-to'))
		open_gallery(init_slide)
	})

	// Init sidebar close
	$("[" + close_attribute + "]").click(function () {
		close_gallery()
	})

	// Keyboard arrows sliding
	$("body").keydown(function (e) {
		if(single_product_lightbox_swiper){
			if (e.keyCode === 38 || e.keyCode === 39) {
				single_product_lightbox_swiper.slideNext();
			} else if (e.keyCode === 37 || e.keyCode === 40) {
				single_product_lightbox_swiper.slidePrev();
			}
		}
	});

	// init_gallery()

	function open_gallery(init_slide){
		setTimeout(() => {
			$('html').addClass('has-modal--lightbox-gallery');
			init_gallery();

			single_product_lightbox_swiper.slideTo(init_slide-1, 0)
			single_product_lightbox_swiper.update()
			single_product_lightbox_swiper_thumbs.setProgress(init_slide-1)

		}, 100)
	}

	function close_gallery(){
		$('html').removeClass('has-modal--lightbox-gallery');
		if (single_product_lightbox_swiper && single_product_swiper) {
			const currentIndex = single_product_lightbox_swiper.realIndex;
			single_product_swiper.slideTo(currentIndex, 0);
		}
	}

	$(document).keyup(function (e) {
		if (e.key === "Escape") { // escape key maps to keycode `27`
			close_gallery()
		}
	});


	// Single product mobile swiper
	var single_product_swiper;
	var prevWidth = 0; // 0 for first init

	function init_single_product_swiper() {

		var currentWidth = window.screen.width

		// Width change only
		if (currentWidth === prevWidth) {
			return
		}
		prevWidth = currentWidth

		if (single_product_swiper && $('.product-detail-gallery-swiper').length) {
			single_product_swiper.destroy()
		}

		// Single product gallery Swiper
		if (currentWidth < 900) {
			single_product_swiper = new Swiper('.product-detail-gallery-swiper', {
				speed: 300,
				slidesPerView: 1,
				watchSlidesProgress: true,
				observer: true,
				scrollbar: {
					el: '.product-detail-gallery__bg .swiper-scrollbar',
					draggable: true,
					hide: false,
				},
			});
		}
	}

	$(window).on('load resize', init_single_product_swiper);

})(jQuery);